 <app-table-title [introText]="introText" [title]="'CLIENT_SEARCH' | dictionary"></app-table-title>

 <div class="row">
   <div class="col-lg-12">
     <div class="m-portlet m-portlet--unair" style="margin-bottom: 0px;">

       <!--------------------- Row 1 ------------------------ -->
       <div class="pr-2 home-middle-header-bgcolor flex"
            *ngIf="displayingFields['TypeOfClient'] || displayingFields['Fund']">
         <div class="form-row col-lg-12 pt-2 pb-2">

           <!--------------------- Type of Client ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['TypeOfClient']">
             <label class="filter-label-width text-right text-color-1">{{'TYPE_OF_CLIENT' | dictionary}}</label>
             <div class="input-wrapper">
               <select class="form-control" [(ngModel)]="userTypeSelected"
                       (ngModelChange)="updateDisplayingFields(); search()">
                 <option *ngFor="let userType of userTypeList" [value]="userType.Key">
                   {{userType.Value}}
                 </option>
               </select>
             </div>
           </div>
           <!--------------------- Fund ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['Fund']">
             <label class="text-right text-color-1 filter-label-width">{{'FUND' | dictionary}}</label>
             <div class="input-wrapper">
               <select class="form-control" [(ngModel)]="fundSelected" (ngModelChange)="search()">
                 <option *ngFor="let fund of fundsList" [value]="fund.FundId">
                   {{fund.Title}}
                 </option>
               </select>
             </div>
           </div>

         </div>
       </div>
       <!--------------------- Row 2 ------------------------ -->
       <div class="pr-2 home-middle-header-bgcolor flex"
            *ngIf="displayingFields['ClientNumber'] || displayingFields['ClientName']">
         <div class="form-row col-lg-12 pt-2 pb-2">
           <!--------------------- Investor (or other type) # ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['ClientNumber']">
             <label class="text-right text-color-1 filter-label-width">{{clientTypeLabel}} #</label>
             <div class="input-wrapper">
               <input type="text" class="form-control" [(ngModel)]="clientTypeNum"
                      (ngModelChange)="onFilterChange(clientTypeNum, true)"
                      maxlength="8"/>
             </div>
           </div>
           <!--------------------- Name ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['ClientName']">
             <label
               class="text-right text-color-1 filter-label-width">{{clientTypeLabel}} {{'NAME' | dictionary}}</label>
             <div class="input-wrapper">
               <input type="text" class="form-control" [(ngModel)]="name" (ngModelChange)="onFilterChange(name)"/>
             </div>
           </div>
           <!--------------------------------------------------- -->
         </div>
       </div>
       <!--------------------- Row 3 ------------------------ -->
       <div class="pr-2 home-middle-header-bgcolor flex"
            *ngIf="displayingFields['HouseAccount'] || displayingFields['InvestmentTaxId']">
         <div class="form-row col-lg-12 pt-2 pb-2">
           <!--------------------- House Account ------------------------ -->
           <div class="col-md-6 col-sm-12 filter-wrapper house-account-checkbox"
                *ngIf="displayingFields['HouseAccount']">
             <div class="checkbox-inner-wrapper">
               <input class="checkbox-field" type="checkbox" [(ngModel)]="houseAccount"
                      (ngModelChange)="updateDisplayingFields(); search()"/>
               <label class="margin-0 text-color-1">{{'HOUSE_ACCOUNT' | dictionary}}</label>
             </div>

           </div>
           <!--------------------- Tax Id # ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['InvestmentTaxId']">
             <label class="text-right text-color-1 filter-label-width">
               <i class="fas fa-question-circle icon text-color-1 cursor-pointer" [pTooltip]="'Last 4 digits only'"></i>
               {{'TAX_ID' | dictionary}} #</label>
             <div class="input-wrapper">
               <input type="text" class="form-control" (keypress)="numberOnly($event)" [(ngModel)]="investmentTaxId"
                      (ngModelChange)="onFilterChange()"
                      maxlength="4"/>
             </div>
           </div>
           <!--------------------------------------------------- -->
         </div>
       </div>
       <!--------------------- Row 4 ------------------------ -->
       <div class="pr-2 home-middle-header-bgcolor flex"
            *ngIf="displayingFields['CRD'] || displayingFields['AccountNum']">
         <div class="form-row col-lg-12 pt-2 pb-2">
           <!--------------------- CRD ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['CRD']">
             <label class="text-right text-color-1 filter-label-width">{{'CRD' | dictionary}}</label>
             <div class="input-wrapper">
               <input type="text" class="form-control" [(ngModel)]="crd" (ngModelChange)="onFilterChange(crd)"/>
             </div>
           </div>
           <!--------------------- Account # ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['AccountNum']">
             <label class="text-right text-color-1 filter-label-width">{{'ACCOUNT' | dictionary}} #</label>
             <div class="input-wrapper">
               <input type="text" class="form-control" [(ngModel)]="accountNum"
                      (ngModelChange)="onFilterChange(accountNum)"
                      maxlength="8"/>
             </div>
           </div>
           <!--------------------------------------------------- -->
         </div>
       </div>

       <!--------------------- Row 5 ------------------------ -->
       <div class="pr-2 home-middle-header-bgcolor flex"
            *ngIf="displayingFields['BrokersRepId'] || displayingFields['Email']">
         <div class="form-row col-lg-12 pt-2 pb-2">
           <!--------------------- Broker's Rep Id ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['BrokersRepId']">
             <label class="text-right text-color-1 filter-label-width">{{'BROKERS_REP_ID' | dictionary}}</label>
             <div class="input-wrapper">
               <input type="text" class="form-control" maxlength="100" [(ngModel)]="brokerRepId"
                      (ngModelChange)="onFilterChange(brokerRepId)"/>
             </div>
           </div>
           <!--------------------- Email Address ------------------------ -->
           <div class="col-md-6 col-sm-12" *ngIf="displayingFields['Email']">
             <label class="text-right text-color-1 filter-label-width">{{'EMAIL_ADDRESS' | dictionary}}</label>
             <div class="input-wrapper">
               <input type="text" class="form-control" [(ngModel)]="email" (ngModelChange)="onFilterChange(email)"
                      maxlength="100"/>
             </div>
           </div>
           <!--------------------------------------------------- -->

         </div>
       </div>

       <!--------------------- Row 6 ------------------------ -->
       <div class="pr-2 home-middle-header-bgcolor flex">
         <div class="form-row col-lg-12 pt-2 pb-2">
           <!--------------------------------------------- -->
           <div class="col-md-6 col-sm-12">
           </div>
           <!--------------------------------------------- -->
           <!-- <div class="col-md-6 col-sm-12 flex-end">
             <button type="button" class="button-1 download-excel-button" (click)="downloadExel()">
               <i class="fas fa-file-excel"></i>Download
             </button>
           </div>  -->
           <!--------------------------------------------------- -->

         </div>
       </div>
     </div>
   </div>
 </div>

 <div class="row table-wrapper">
   <div class="col-lg-12 table-wrapper-inner">
     <kendo-grid #kendoGridComponent [data]="filteredGridData" [loading]="loading" [height]="heightOfGridContainer"
                 [navigable]="true" [sortable]="{allowUnsort: false, mode: 'single'}" [sort]="sort"
                 (sortChange)="sortChange($event)" (scrollBottom)="loadMore($event)">

       <ng-container *ngFor="let column of columnListBasedOnTypeSelected">
         <kendo-grid-column field="{{column.Field}}" title="{{column.Title}}"
                            [headerClass]="'gridheader text-color-1'" [width]="column.Width">
           <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
             <a *ngIf="column.IsHyperLink" href="javascript:void(0)" (click)="openEntityRecord(dataItem)">
               {{dataItem[column.Field]}}
             </a>
             <span *ngIf="!column.IsHyperLink"> {{dataItem[column.Field]}}</span>
           </ng-template>
         </kendo-grid-column>
       </ng-container>


     </kendo-grid>
   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>
